// extracted by mini-css-extract-plugin
export default {"content":"H2X7CtnGiq20gGfh5S2V","msg":"i9hhkhC9rlrO1cMmxHYb","quantityMsg":"QJnyvyyfzSdmaFC_kFcx"};